/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_INGREDIENTS } from '../../actions.type'
import {
  CREATE_INGREDIENT,
  REMOVE_INGREDIENT,
  SET_INGREDIENT_ALL_REQUEST,
  SET_INGREDIENT_ALL_VALUE,
  UPDATE_INGREDIENT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  ingredientAllValue: (state) => state.all.value,
  ingredientAllRequest: (state) => state.all.request,
  ingredientAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_INGREDIENTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('ingredient', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_INGREDIENT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_INGREDIENT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_INGREDIENT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_INGREDIENT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_INGREDIENT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_INGREDIENT({ commit }, value) {
    commit(CREATE_INGREDIENT, value)
  },

  async SOCKET_UPDATE_INGREDIENT({ commit }, value) {
    commit(UPDATE_INGREDIENT, value)
  },

  async SOCKET_REMOVE_INGREDIENT({ commit }, id) {
    commit(REMOVE_INGREDIENT, id)
  }
}

const mutations = {
  [SET_INGREDIENT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_INGREDIENT_ALL_VALUE](state, ingredients) {
    state.all.value = ingredients
  },
  [UPDATE_INGREDIENT](state, updatedIngredient) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedIngredient.id }),
      1,
      updatedIngredient
    )
  },
  [CREATE_INGREDIENT](state, createdIngredient) {
    state.all.value.push(createdIngredient)
  },
  [REMOVE_INGREDIENT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
